import { useState } from "react";
import { CheckOutVehicle } from "./CheckOutVehicleRefactor";
import { CheckOutVisitorList } from "./CheckOutVisitorList";
import { CheckInSuccess } from "../CheckIn/CheckInSuccess";
import { useTranslation } from "react-i18next";
import { PageLayout } from "../../Components/PageLayout";

const PageButtons = ({ setForm }) => {
  const { t } = useTranslation();
  return (
    <div className="">
      <div className="overview-header">
        <h1 className="global-h1 light-black">{t("page-headers.check-out")}</h1>
      </div>
      <div className="form-cont">
        <h4 className=" global-h4 bottom-space">
          {t("forms.type.check-out-header")}
        </h4>
        <div className="flex-1">
          <button
            id="vehicle-btn"
            data-testid="vehicle-btn"
            onClick={() => setForm("Vehicle")}
            className="check-in-option"
          >
            {t("buttons.vehicle")}
          </button>
          <button
            onClick={() => setForm("Visitor")}
            className="check-in-option"
          >
            {t("buttons.visitor")}
          </button>
        </div>
      </div>
    </div>
  );
};
export const CheckOut = () => {
  const [checkForm, setForm] = useState("");
  const [success, setSuccess] = useState(false);
  const { t } = useTranslation();

  const handleClose = () => {
    setForm("");
  };

  return (
    <PageLayout title={"Check Out"}>
      <div className="checkin-wrapper">
        {!checkForm && <PageButtons setForm={setForm} />}
        {checkForm === "Vehicle" ? (
          <div className="">
            <CheckOutVehicle onClose={handleClose} />
          </div>
        ) : null}
        {checkForm === "Visitor" ? (
            <CheckOutVisitorList onClose={handleClose} />
        ) : null}
        {success ? (
          <div>
              <CheckInSuccess
                title={t("forms.type.success")}
                message={t("forms.type.check-out-success")}
              />
          </div>
        ) : null}
      </div>
    </PageLayout>
  );
};
